import { render, staticRenderFns } from "./relatorioExtracaoBase.vue?vue&type=template&id=264166cc"
import script from "./relatorioExtracaoBase.vue?vue&type=script&lang=js"
export * from "./relatorioExtracaoBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports